/**
 * BasicInfoTab — Read-only display of server details and health status.
 *
 * Two pp-section cards:
 *   1. "Server Details" — name, MAC, interface, hardware, OS, IP, area
 *   2. "Status & Health" — heartbeat, alarms, reboot, uptime, online status
 */

const BasicInfoTab = ({
  serverName, macAddr, interfaceName, product, areaName,
  os, hardware, ipAddr, isActive,
  lastHeartbeat, recentAlarmTime, activeAlarmsCount,
  lastReboot, uptime, isOffline, isCloud, loading,
  editRights, onEdit,
}) => {
  if (loading) {
    return (
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Server Details</h3>
        </div>
        <div className="pp-section__body">
          <p style={{ color: 'var(--color-text-tertiary)' }}>Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Server Details */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Server Details</h3>
          <div className="pp-section__actions">
            {editRights && (
              <button className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
                ✎ Edit
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body">
          <div className="pp-field-grid">
            <div className="pp-field">
              <span className="pp-field__label">Description</span>
              <span className="pp-field__value">{serverName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">MAC Address</span>
              <span className="pp-field__value pp-field__value--mono">{macAddr || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Interface</span>
              <span className="pp-field__value">{interfaceName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Product</span>
              <span className="pp-field__value">{product || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Hardware</span>
              <span className="pp-field__value">{hardware || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Operating System</span>
              <span className="pp-field__value">{os || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">IP Address</span>
              <span className="pp-field__value pp-field__value--mono">{ipAddr || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Area</span>
              <span className="pp-field__value">{areaName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Status</span>
              <span className="pp-field__value">
                <span className={`dp-status dp-status--${isActive ? 'active' : 'inactive'}`}>
                  <span className="dp-status__dot" />
                  {isActive ? 'Active' : 'Inactive'}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Status & Health */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Status &amp; Health</h3>
        </div>
        <div className="pp-section__body">
          <div className="pp-field-grid">
            <div className="pp-field">
              <span className="pp-field__label">Last Heartbeat</span>
              <span className="pp-field__value">{lastHeartbeat || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Last Alarm</span>
              <span className="pp-field__value">{recentAlarmTime || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Active Alarms</span>
              <span className="pp-field__value">{activeAlarmsCount !== '' ? activeAlarmsCount : '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Last Reboot</span>
              <span className="pp-field__value">{lastReboot || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Uptime (Hours)</span>
              <span className="pp-field__value">{uptime !== '' ? uptime : '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Online Status</span>
              <span className="pp-field__value">
                {isCloud ? (
                  <span className={`dp-status dp-status--${isOffline != null && !isOffline ? 'active' : isOffline != null && !!isOffline ? 'inactive' : 'warning'}`}>
                    <span className="dp-status__dot" />
                    {isOffline != null && !isOffline ? 'Online' : isOffline != null && !!isOffline ? 'Offline' : 'Unknown'}
                  </span>
                ) : (
                  <span className="dp-status dp-status--active">
                    <span className="dp-status__dot" />
                    Connected
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfoTab;
